"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainClub = mapToDomainClub;
function mapToDomainClub(dto) {
    return {
        clubId: dto.clubId,
        clubName: dto.clubName,
        location: dto.location,
    };
}
